<figure class="preview">
  <figcaption>Prévia</figcaption>
  <div class="preview-editor">
    <ngx-monaco-editor [options]="previewOptions" [(ngModel)]="previewCode" (init)="onPreviewInit($event)" />
  </div>
</figure>

<div class="field">
  <div class="field-text">
    <span id="setting-editor-font-size" class="field-label">Tamanho da fonte</span>
    <p id="setting-editor-font-size-descricao" class="field-description">
      Usado no editor e, até ser alterado na seção Saída, também na saída. O padrão é
      {{ settings.editorFontSize.default }}px.
    </p>
  </div>

  <app-font-size-control
    labelledBy="setting-editor-font-size"
    describedBy="setting-editor-font-size-descricao"
    [(value)]="editorFontSize"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-word-wrap" class="field-label">Quebra de linha</span>
    <p id="setting-editor-word-wrap-descricao" class="field-description">
      Linhas longas continuam embaixo em vez de rolar para o lado.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-word-wrap"
    aria-describedby="setting-editor-word-wrap-descricao"
    [(ngModel)]="editorWordWrap"
  />
</div>

<div class="row">
  <div class="field">
    <span id="setting-editor-tab-size" class="field-label">Tamanho da tabulação</span>

    <div class="segmented tab-size" role="radiogroup" aria-labelledby="setting-editor-tab-size">
      @for (size of tabSizes; track size) {
        <label
          ><input
            type="radio"
            class="visually-hidden"
            name="tabSize"
            [value]="size"
            [(ngModel)]="editorTabSize"
          /><span>{{ size }}</span></label
        >
      }
    </div>
  </div>

  <div class="field">
    <span id="setting-editor-insert-spaces" class="field-label">Indentar com</span>

    <div class="segmented" role="radiogroup" aria-labelledby="setting-editor-insert-spaces">
      <label
        ><input
          type="radio"
          class="visually-hidden"
          name="insertSpaces"
          [value]="true"
          [(ngModel)]="editorInsertSpaces"
        /><span>Espaços</span></label
      >
      <label
        ><input
          type="radio"
          class="visually-hidden"
          name="insertSpaces"
          [value]="false"
          [(ngModel)]="editorInsertSpaces"
        /><span>Tabulações</span></label
      >
    </div>
  </div>
</div>

<hr />

<div class="field">
  <div class="field-text">
    <span id="setting-editor-line-numbers" class="field-label">Números das linhas</span>
    <p id="setting-editor-line-numbers-descricao" class="field-description">
      Relativos contam a partir da linha do cursor.
    </p>
  </div>

  <div
    class="segmented"
    role="radiogroup"
    aria-labelledby="setting-editor-line-numbers"
    aria-describedby="setting-editor-line-numbers-descricao"
  >
    <label
      ><input type="radio" class="visually-hidden" name="lineNumbers" value="on" [(ngModel)]="editorLineNumbers" /><span
        >Exibir</span
      ></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="lineNumbers"
        value="relative"
        [(ngModel)]="editorLineNumbers"
      /><span>Relativos</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="lineNumbers"
        value="off"
        [(ngModel)]="editorLineNumbers"
      /><span>Ocultar</span></label
    >
  </div>
</div>

<div class="field">
  <div class="field-text">
    <span id="setting-editor-render-line-highlight" class="field-label">Destacar a linha atual</span>
    <p id="setting-editor-render-line-highlight-descricao" class="field-description">
      Uma faixa marca a linha onde está o cursor.
    </p>
  </div>

  <div
    class="segmented"
    role="radiogroup"
    aria-labelledby="setting-editor-render-line-highlight"
    aria-describedby="setting-editor-render-line-highlight-descricao"
  >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="renderLineHighlight"
        value="none"
        [(ngModel)]="editorRenderLineHighlight"
      /><span>Nunca</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="renderLineHighlight"
        value="line"
        [(ngModel)]="editorRenderLineHighlight"
      /><span>No código</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="renderLineHighlight"
        value="all"
        [(ngModel)]="editorRenderLineHighlight"
      /><span>No código e na margem</span></label
    >
  </div>
</div>

<div class="field">
  <div class="field-text">
    <span id="setting-editor-render-whitespace" class="field-label">Exibir espaços em branco</span>
    <p id="setting-editor-render-whitespace-descricao" class="field-description">
      Espaços aparecem como pontos e tabulações como setas.
    </p>
  </div>

  <div
    class="segmented"
    role="radiogroup"
    aria-labelledby="setting-editor-render-whitespace"
    aria-describedby="setting-editor-render-whitespace-descricao"
  >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="renderWhitespace"
        value="none"
        [(ngModel)]="editorRenderWhitespace"
      /><span>Nunca</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="renderWhitespace"
        value="selection"
        [(ngModel)]="editorRenderWhitespace"
      /><span>Na seleção</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="renderWhitespace"
        value="all"
        [(ngModel)]="editorRenderWhitespace"
      /><span>Sempre</span></label
    >
  </div>
</div>

<div class="field">
  <span id="setting-editor-cursor-style" class="field-label">Estilo do cursor</span>

  <div class="segmented" role="radiogroup" aria-labelledby="setting-editor-cursor-style">
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="cursorStyle"
        value="line"
        [(ngModel)]="editorCursorStyle"
      /><span>Linha</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="cursorStyle"
        value="block"
        [(ngModel)]="editorCursorStyle"
      /><span>Bloco</span></label
    >
    <label
      ><input
        type="radio"
        class="visually-hidden"
        name="cursorStyle"
        value="underline"
        [(ngModel)]="editorCursorStyle"
      /><span>Sublinhado</span></label
    >
  </div>
</div>

<hr />

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-quick-suggestions" class="field-label">Sugestões ao digitar</span>
    <p id="setting-editor-quick-suggestions-descricao" class="field-description">
      Palavras e comandos aparecem numa lista enquanto você escreve. Desativadas, ainda abrem com Ctrl + Espaço.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-quick-suggestions"
    aria-describedby="setting-editor-quick-suggestions-descricao"
    [(ngModel)]="editorQuickSuggestions"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-live-diagnostics" class="field-label">Mostrar erros enquanto digita</span>
    <p id="setting-editor-live-diagnostics-descricao" class="field-description">
      Desativado, os erros só são marcados no código ao executar.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-live-diagnostics"
    aria-describedby="setting-editor-live-diagnostics-descricao"
    [(ngModel)]="editorLiveDiagnostics"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-auto-closing" class="field-label">Fechar chaves e aspas automaticamente</span>
    <p id="setting-editor-auto-closing-descricao" class="field-description">
      Ao abrir chaves, parênteses ou aspas, o fechamento já aparece.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-auto-closing"
    aria-describedby="setting-editor-auto-closing-descricao"
    [(ngModel)]="editorAutoClosing"
  />
</div>

<hr />

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-minimap" class="field-label">Minimapa</span>
    <p id="setting-editor-minimap-descricao" class="field-description">
      Miniatura do código ao lado da barra de rolagem.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-minimap"
    aria-describedby="setting-editor-minimap-descricao"
    [(ngModel)]="editorMinimap"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-indentation-guides" class="field-label">Guias de indentação</span>
    <p id="setting-editor-indentation-guides-descricao" class="field-description">
      Linhas verticais ligando o início e o fim de cada bloco.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-indentation-guides"
    aria-describedby="setting-editor-indentation-guides-descricao"
    [(ngModel)]="editorIndentationGuides"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-bracket-pair-colorization" class="field-label">Colorir pares de chaves e parênteses</span>
    <p id="setting-editor-bracket-pair-colorization-descricao" class="field-description">
      Cada nível de chaves e parênteses ganha uma cor.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-bracket-pair-colorization"
    aria-describedby="setting-editor-bracket-pair-colorization-descricao"
    [(ngModel)]="editorBracketPairColorization"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-folding" class="field-label">Recolher blocos</span>
    <p id="setting-editor-folding-descricao" class="field-description">
      Setas na margem escondem e mostram o conteúdo de cada bloco.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-folding"
    aria-describedby="setting-editor-folding-descricao"
    [(ngModel)]="editorFolding"
  />
</div>

<div class="field inline">
  <div class="field-text">
    <span id="setting-editor-sticky-scroll" class="field-label">Fixar o bloco atual no topo</span>
    <p id="setting-editor-sticky-scroll-descricao" class="field-description">
      Ao rolar, a linha de início da função e dos blocos em que o cursor está fica visível no alto do editor.
    </p>
  </div>

  <input
    type="checkbox"
    role="switch"
    class="switch"
    aria-labelledby="setting-editor-sticky-scroll"
    aria-describedby="setting-editor-sticky-scroll-descricao"
    [(ngModel)]="editorStickyScroll"
  />
</div>
